const initQtySelectors = () => {
	$('.js-qty').each(function() {
		const $container = $(this);
		const $incButton = $('.js-qty-inc', $container);
		const $decButton = $('.js-qty-dec', $container);
		const $field = $('.js-qty-field', $container);
		const min = $field.data('min');

		if (min >= Number($field.val())) {
			$decButton.addClass('disabled');
		}

		$incButton.on('click', function() {
			const currentVal = Number($field.val());

			$field.val(currentVal + 1).trigger('change');

			$decButton.removeClass('disabled');
		});

		$decButton.on('click', function() {
			const currentVal = Number($field.val());

			if (min >= currentVal - 1) {
				$decButton.addClass('disabled');
			}

			if (min < currentVal) {
				$field.val(currentVal - 1).trigger('change');
			}
		});

		$field.on('change', function() {
			const currentVal = Number($field.val());

			$decButton.toggleClass('disabled', min > currentVal - 1);
		});
	});
}

export default function qtyUI() {
	initQtySelectors();
};
